import { useState } from 'react';
import styled from 'styled-components';
import FaqMenuBar from '~/components/FaqMenuBar';
import FaqQuestions from '~/components/FaqQuestions';
import { CustomHead } from '~/components/Head';
import StaticPageLayout from '~/components/layouts/StaticPageLayout';
import faqs from '~/data/faq';
import theme from '~/styles/styledComponentsTheme';
import React from 'react';
import dynamic from 'next/dynamic';
import Typography from '~/atoms/Typography';
import VideoPlayback from '~/components/VideoPlayer/VideoPlayback';
import ReactJWPlayer from 'react-jw-player';
import { CtaColorScheme, CtaLink } from '../../components/cta/regular';
import Flex from '../../components/Flex';

const Content = styled.div`
    display: flex;
    flex-direction: column;

    @media screen and ${theme.breakpoints.laptop} {
        flex-direction: row;
        margin-top: 30px;
    }
`;

const Paragraph = styled.div`
    font-size: 1.5rem;
    line-height: 2rem;
    text-align: center;
    @media screen and ${theme.breakpoints.isMobile} {
        margin-bottom: 25px;
    }
`;

const ParagraphHeader = styled(Paragraph)`
    text-decoration: underline;
    font-weight: bold;
`;

const Title = styled.div`
    font-size: 2rem;
    line-height: 2.1rem;
    text-align: center;
    margin-bottom: 25px;

    @media screen and ${theme.breakpoints.isMobile} {
        margin-bottom: 25px;
    }
`;

export const StyledFaqQuestions = styled(FaqQuestions)`
    width: 100%;

    @media screen and ${theme.breakpoints.laptop} {
        margin-left: 46px;
    }
`;

export const VidContainer = styled.div`
    width: 100%;
    @media screen and ${theme.breakpoints.laptop} {
        width: 100%;
        margin: 0 auto;
    }
`;

export const SponsorLogo = styled.div`
    display: inline-block;
    width: 100%;
    text-align: center;

    font-size: 1.5rem;
    line-height: 1.5rem;

    @media screen and ${theme.breakpoints.laptop} {
        font-size: 2rem;
        line-height: 2rem;
    }
    img {
        width: 300px;
        height: auto;
        cursor: pointer;

        @media screen and ${theme.breakpoints.laptop} {
            width: 544px;
            height: auto;
            margin: 0 auto;
        }
    }
`;

export const SponsorLogoSmall = styled.div`
    display: inline-block;
    width: 100%;
    text-align: center;

    font-size: 1.5rem;
    line-height: 1.5rem;

    @media screen and ${theme.breakpoints.laptop} {
        font-size: 2rem;
        line-height: 2rem;
    }
    img {
        width: 150px;
        cursor: pointer;

        @media screen and ${theme.breakpoints.laptop} {
            width: 272px;
            margin: 0 auto;
        }
    }
`;

export const Channel = styled.div`
    img {
        max-width: 100px;
    }

    padding: 5px;
`;

export const ChannelLarger = styled.div`
    img {
        width: 400px;
        max-width: 400px;
        height: auto;
    }

    padding: 5px;
`;

export const ChannelLineup = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
`;

export const ItemList = styled.ul`
    margin-left: 20px;
    list-style-type: '-   ';
    font-size: 12px;
    line-height: 1.6em;
    padding: 0 1em;

    li {
        font-size: 1.4rem;
        line-height: 1.7rem;

        a {
            color: blue;
        }
    }
`;

export const Bold = styled.span`
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 1.6em;
`;

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const Player = dynamic(() => import('react-hls-player'), { ssr: false });

const LSTVLivePlayerPage = () => {
    return (
        <>
            <CustomHead
                title="On The Runway"
                titleOg={'On The Runway'}
                description={
                    'We&apos;re taking you behind the scenes of the world&apos;s most prestigious bridal fashion shows starting with Barcelona Bridal Fashion Week and continuing into Fall 2024 and beyond.'
                }
                image={'https://cdn.lovestoriestv.com/ext/on-the-runway/on-the-runway.jpg'}
                url={`/on-the-runway`}
            />
            <StaticPageLayout wideContent headerText="On The Runway">
                <SponsorLogo>
                    Brought To You By
                    <br />
                    <a rel="noreferrer" href="https://platinumjewelry.com/" target="_blank">
                        <img
                            src="https://cdn.lovestoriestv.com/ext/on-the-runway/Platinum2.png"
                            alt="Platinum Jewelry"
                        />
                    </a>
                </SponsorLogo>

                <VidContainer>
                    <VideoPlayback
                        noContainer={true}
                        uniqueId="thumbnailChooserVideoPlayback"
                        videoType="jwplayer"
                        videoWidth="100%"
                        mediaID={'9SBhbGZs'}
                        isMuted={true}
                        withPreRoll={false}
                        showLoadingMessage={false}
                        isAutoPlay={false}
                    />
                </VidContainer>

                {/*<div style={{width: '100%', position: 'relative', overflow: 'hidden', aspectRatio: '16 / 9'}}>*/}
                {/*<iframe src="https://cdn.jwplayer.com/players/CkyUmA7J-24ane4MY.html" width="100%" height="100%" frameBorder="0"*/}
                {/*        scrolling="auto" title="On The Runway" allowFullScreen></iframe>*/}
                {/*</div>*/}

                <br />
                <Paragraph>
                    We&apos;re taking you behind the scenes of the world&apos;s most prestigious bridal fashion shows
                    starting with Barcelona Bridal Fashion Week and continuing into Fall 2024 and beyond. On the Runway
                    will give you an exclusive first look at the beginning to end fabrication of a bridal collection
                    where we highlight the creative process through voice of the designers gathering their inspiration
                    and outlooks on the latest trends and styles. Each episode culminates on the runway where
                    you&apos;ll see jaw dropping designs by the best of the best. Visit each designer&apos;s page to see
                    their collection and learn more about the brand.
                </Paragraph>

                <br />
                <br />
                <br />

                <SponsorLogoSmall>
                    Get in touch with us for Fall On the Runway partnership opportunities.
                    <br />
                    <br />
                    <CtaLink
                        to={'mailto:partnerships@lovestoriestv.com'}
                        $colorScheme={CtaColorScheme.Dark}
                        caption={'Get In Touch'}
                    />
                </SponsorLogoSmall>
                <br />
                <br />
                <br />
                <br />
                <br />
                <SponsorLogoSmall>
                    You may also be interested in
                    <br />
                    <br />
                    <ChannelLineup>
                        <ChannelLarger>
                            <PageContainer>
                                <a rel="noreferrer" href="/on-the-runway/nicole-milano">
                                    <img
                                        src="https://cdn.lovestoriestv.com/ext/on-the-runway/s6-nocole-milano.jpg"
                                        alt="Nicole Milano"
                                    />
                                </a>
                                <Bold>Nicole Milano</Bold>
                            </PageContainer>
                        </ChannelLarger>

                        <ChannelLarger>
                            <PageContainer>
                                <a rel="noreferrer" href="/on-the-runway/pronovias">
                                    <img
                                        src="https://cdn.lovestoriestv.com/ext/on-the-runway/s7-provonias.jpg"
                                        alt="Pronovias"
                                    />
                                </a>
                                <Bold>Pronovias</Bold>
                            </PageContainer>
                        </ChannelLarger>

                        <ChannelLarger>
                            <PageContainer>
                                <a rel="noreferrer" href="/on-the-runway/demetrios">
                                    <img
                                        src="https://cdn.lovestoriestv.com/ext/on-the-runway/s8-demetrios.jpg"
                                        alt="Demetrios"
                                    />
                                </a>
                                <Bold>Demetrios</Bold>
                            </PageContainer>
                        </ChannelLarger>
                        <ChannelLarger>
                            <PageContainer>
                                <a rel="noreferrer" href="/on-the-runway/madeline">
                                    <img
                                        src="https://cdn.lovestoriestv.com/ext/on-the-runway/s9-madeline.jpg"
                                        alt="Madeline"
                                    />
                                </a>
                                <Bold>MADELINE</Bold>
                            </PageContainer>
                        </ChannelLarger>
                    </ChannelLineup>
                </SponsorLogoSmall>

                <br />
                <br />
                <br />
                <br />
                <Title>Watch on The Love Stories TV Channel. Available on the following apps:</Title>
                <ChannelLineup>
                    <Channel>
                        <img src=" https://cdn.lovestoriestv.com/ext/live-page-logos/live-fubotv.png" alt="fubo" />
                    </Channel>

                    <Channel>
                        <a
                            rel="noreferrer"
                            href="https://watch.sling.com/dashboard/search/1/channel/618a12baf4f14624b2e896517ec20e9a/browse"
                            target="_blank"
                        >
                            <img src="https://cdn.lovestoriestv.com/ext/live-page-logos/sling.png" alt="sling" />
                        </a>
                    </Channel>

                    <Channel>
                        <a
                            rel="noreferrer"
                            href="https://www.redbox.com/stream-free-live-tv?channel=love_stories_tv"
                            target="_blank"
                        >
                            <img src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-redbox.png" alt="redbox" />
                        </a>
                    </Channel>

                    <Channel>
                        <a
                            rel="noreferrer"
                            href="https://rakuten.tv/uk/live_channels/love-stories-tv?q=love"
                            target="_blank"
                        >
                            <img src="https://cdn.lovestoriestv.com/ext/live-page-logos/rakuten.png" alt="rakuten" />
                        </a>
                    </Channel>

                    <Channel>
                        <a rel="noreferrer" href="https://localnow.com/channels/epg-love-stories-tv" target="_blank">
                            {' '}
                            <img
                                src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-localnow.png"
                                alt="localnow"
                            />
                        </a>
                    </Channel>

                    <Channel>
                        <a rel="noreferrer" href="https://thegrio.com" target="_blank">
                            {' '}
                            <img
                                src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-thegrio.png"
                                alt="thegrio"
                            />
                        </a>
                    </Channel>

                    <Channel>
                        {' '}
                        <a rel="noreferrer" href="https://www.tclchannel.com/" target="_blank">
                            <img src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-tcl.png" alt="tcl" />
                        </a>
                    </Channel>
                    <Channel>
                        <a rel="noreferrer" href="https://www.vidaa.com/" target="_blank">
                            <img src="https://cdn.lovestoriestv.com/ext/live-page-logos/vidaa.png" alt="vidaa" />
                        </a>
                    </Channel>

                    <Channel>
                        <a rel="noreferrer" href="https://stremium.com/" target="_blank">
                            <img
                                src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-stremium.png"
                                alt="stremium"
                            />
                        </a>
                    </Channel>

                    <Channel>
                        <a
                            rel="noreferrer"
                            href="https://www.amazon.com/OTT-Studio-Free-Movies-Plus/dp/B08JPDLL1Z"
                            target="_blank"
                        >
                            <img
                                src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-free-movies-plus.png"
                                alt="freemoviesplus"
                            />
                        </a>
                    </Channel>

                    <Channel>
                        <a rel="noreferrer" href="https://www.mi.com/us/product/mi-tv-stick/" target="_blank">
                            <img src="https://cdn.lovestoriestv.com/ext/live-page-logos/live-xiaomi.png" alt="xiaomi" />
                        </a>
                    </Channel>
                </ChannelLineup>
            </StaticPageLayout>
        </>
    );
};

export default LSTVLivePlayerPage;
